<!--
	@name app-dialog-select-panel
	@description Show a dialog for selecting panel
	@date 2024/03/28
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name" persistent :show-close="showClose">
		<template #header>
			Select Panel
		</template>
		<template #body>
			<p class="text-body-1 mb-4 font-weight-medium">
				Select the panel that you will be using
			</p>
			<div v-if="orderedPanels.length">
				<v-list-item v-for="(item, index) in orderedPanels" :key="item.id" :class="{ 'mt-1': index !== 0 }" @click="selectPanel(item)">
					<v-list-item-title v-text="item.name" />
				</v-list-item>
			</div>
			<div v-else>
				<v-card v-for="key in 3" :key="key" class="mb-2">
					<v-skeleton-loader type="list-item-two-line" />
				</v-card>
			</div>
			<common-dialog-confirm ref="confirm" />
		</template>
	</common-dialog>
</template>

<script>
	import { mapActions, mapState, mapMutations } from 'vuex';
	import CommonDialog from '@/component/common/dialog';
	import CommonDialogConfirm from '@/component/common/dialog/confirm';
	import { ElementTools, EventBus } from '@/utils';
	import { orderBy } from 'lodash';

	export default {
		name: 'app-dialog-select-panel',

		components: { CommonDialog, CommonDialogConfirm },

		data: () => ({
			showClose: false
		}),

		computed: {
			...mapState('Account', ['user']),
			...mapState('AccountPanel', ['panelList']),

			orderedPanels() {
				return [{ id: null, name: 'Whole of Market' }, ...(orderBy(this.panelList, 'created', ['desc']) || [])];
			}
		},

		methods: {
			...mapActions('Account', ['modifyUser']),
			...mapMutations('Account', ['setUser']),

			/**
			 * @name open
			 * @description Open dialog and set properties
			 */
			open(click) {
				if (click) {
					this.showClose = true;
					this.$refs.dialog.open();
				}
			},

			/**
			 * @name selectPanel
			 * @description select the active panel
			 */
			selectPanel(item) {
				this.$refs.dialog.close();

				this.modifyUser({
					data: {
						panel: item.id
					}
				})
					.then(() => {
						EventBus.$emit('panel-selected', { id: item.id, name: item.name });
						ElementTools.fireNotification(this.$el, 'success', `You have selected ${item.name} as your panel`);
					})
					.catch((e) => {
						console.log(e);
					});
			}
		}
	};
</script>
